import { render, staticRenderFns } from "./memberAddressComponent.vue?vue&type=template&id=94807ce4&"
import script from "./memberAddressComponent.vue?vue&type=script&lang=ts&"
export * from "./memberAddressComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports